import { render } from "./Root.vue?vue&type=template&id=375dc6ad"
import script from "./Root.vue?vue&type=script&lang=ts"
export * from "./Root.vue?vue&type=script&lang=ts"
script.render = render

export default script